module.exports = __webpack_public_path__ + "static/media/homepage_main.cc8a92be.png";